
/**
 * 특정 로드맵에 속한 강의만 필터링
 */
export type RoadmapIdParamParameter = number;
